<div class="container">
    <mat-card-content>
        <div class="row">
            <mat-form-field appearance="outline" class="custom-input-field" fxFlex="40" *ngIf="isBillerApplePay()">
                <mat-label>Defer Reason</mat-label>
                <mat-select placeholder="Select Defer Reason" (selectionChange)="deferReasonChange($event)">
                    <mat-option value="0">No information</mat-option>
                    <mat-option value="1">Customer satisfaction</mat-option>
                    <mat-option value="2">Other reasons</mat-option>
                    <mat-option value="3">Service issue or outage</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="mat-form-field" fxFlex="40">
                <mat-label>Enter Defer days</mat-label>
                <input matInput type="number" min="1" max="90" required [(ngModel)]="enteredDeferDays" (keypress)="validateDeferInput($event)" #daysInput="ngModel">
                <mat-error *ngIf="daysInput.invalid && daysInput.touched">
                    Only 1 to 90 days are allowed.
                </mat-error>
            </mat-form-field>
            <button mat-raised-button [ngClass]="enableDeferButton() ? 'defer-button' : 'disabled-button'"
                class="defer-button" type="submit" [disabled]="!enableDeferButton()"
                (click)="deferSubscription()">Defer</button>
        </div>
    </mat-card-content>
</div>